import React from "react";
import { TableCell } from "@mui/material";
import { StyledTableRow } from "../../../../components/customComponent";
// TODO import { formattedDate } from "../../../../helpers/dateFormat";
import RemoveSingleBreakdown from "./RemoveSingleBreakdown";

const EquipmentItem = ({ equipment }) => {
  return (
    <StyledTableRow>
      <TableCell>
        {equipment.station.code} - {equipment.station.name}
      </TableCell>
      <TableCell>{equipment.name}</TableCell>
      {/* TODO */}
      {/* <TableCell>{formattedDate(equipment.updatedAt)}</TableCell> */}
      <TableCell align="right">
        <RemoveSingleBreakdown equipment={equipment} />
      </TableCell>
    </StyledTableRow>
  );
};

export default EquipmentItem;
